module.exports = __webpack_public_path__ + "static/media/main_skybox_DN.8c46bc9f.png";